import React from 'react';
import ReactDOM from 'react-dom';

import { assertIsDefined } from '@utils/assertIsDefined';

interface ModalContainerProps {
    children: React.ReactNode | React.ReactNode[];
}

export class RightMenuPortal extends React.Component<ModalContainerProps> {
    public modalRoot: HTMLElement;
    public element: HTMLElement;

    constructor(props: ModalContainerProps) {
        super(props);

        const modalRoot = document.getElementById('modal-root');
        assertIsDefined(modalRoot, 'index.html must contain the #modal-root element');
        this.modalRoot = modalRoot;
        this.element = document.createElement('div');
    }

    public componentDidMount(): void {
        this.modalRoot.appendChild(this.element);
    }

    public componentWillUnmount() {
        this.modalRoot.removeChild(this.element);
    }

    public render(): React.ReactNode {
        return ReactDOM.createPortal(this.props.children, this.element);
    }
}
